import { getPatientDetailsCards, PatientStatusPill } from "@/components";
import { usePatientsLists } from "@/hooks";
import { CollapsibleCard, SideModal } from "@/ui";
import type { PatientsListStatus } from "@/utils";

interface PatientDetailsSideModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  patientId: string;
  activeTab: PatientsListStatus;
}

export const PatientDetailsSideModal = ({
  isOpen,
  onOpenChange,
  patientId,
  activeTab,
}: PatientDetailsSideModalProps) => {
  const { usePatientDetails } = usePatientsLists();
  const { data: patientDetails, isLoading: isLoadingDetails } =
    usePatientDetails(patientId, activeTab, Boolean(patientId));

  return (
    <SideModal isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col justify-items-start gap-4">
        <div className="flex justify-between">
          {patientDetails?.generalInformation.firstName ? (
            <h1 className="text-3xl font-medium text-primary-950">
              {patientDetails.generalInformation.firstName}{" "}
              {patientDetails.generalInformation.lastName}
            </h1>
          ) : (
            <div className="h-5 w-1/3 animate-pulse bg-neutral-200" />
          )}

          <PatientStatusPill status={activeTab} />
        </div>
        {patientDetails &&
          getPatientDetailsCards(patientDetails).map((card, index) =>
            card.isCompleted ? (
              <CollapsibleCard
                key={index}
                title={card.title}
                icon={card.icon}
                data={card.data}
              />
            ) : null,
          )}

        {isLoadingDetails && (
          <div className="flex flex-col justify-items-start gap-4">
            {[...Array(6).keys()].map((key) => (
              <div
                key={key}
                className="rounded-lg border border-neutral-100 p-3"
              >
                <div className="flex items-center gap-2 p-1">
                  <div className="h-5 w-5 animate-pulse rounded-full bg-neutral-200" />
                  <div className="h-4 w-1/3 animate-pulse rounded bg-neutral-200" />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </SideModal>
  );
};
